// Single source of truth for the capture_items flush UPDATE (audit-1c2-#2).
//
// The adapter (capture-client-powersync.ts flushCoalesce) executes THIS exact
// SQL, and the real-engine test (capture-client-powersync-rmw-sqlite.test.ts)
// imports and runs THIS string against a node:sqlite view + INSTEAD OF UPDATE
// trigger. So the real-engine proof binds the adapter's ACTUAL SQL instead of a
// hand-copied duplicate — reverting the `sync_version = sync_version + 1`
// read-modify-write now reddens the real-engine test, not merely a copy of it.
// The RMW shape is additionally pinned by
// scripts/lint-powersync-capture-increment-rmw.mjs.
//
// Kept in its own leaf module (no PowerSync/React imports) so the node-env
// real-engine test can import it without pulling in the browser adapter graph.
//
// Param order: [quantity, isZeroConfirmed (0 | 1), notes, itemId].
//
// The `_metadata = json_object(<the row's OWN FK columns>)` clause snapshots the
// immutable FK context (building/space/asset_type/session/site + captured_at)
// onto this PATCH's CRUD entry while the local row is still present — the
// bare-row recovery fix from main's capture-item-increment-sql.ts (e240efd),
// carried over verbatim in the cascade merge (chore/cascade-main-to-staging).
// `metadata` is NOT value-diffed and survives the row's deletion in the upload
// queue; SQLite evaluates the json_object() column references against the
// PRE-UPDATE row values (read-not-written — no LWW effect). Requires
// `trackMetadata: true` on capture_items (schema.ts).
export const CAPTURE_ITEM_FLUSH_SQL = `UPDATE capture_items
   SET quantity = ?,
       is_zero_confirmed = ?,
       notes = ?,
       sync_version = sync_version + 1,
       updated_at = strftime('%Y-%m-%dT%H:%M:%fZ','now'),
       _metadata = json_object(
         'capture_session_id', capture_session_id,
         'site_id', site_id,
         'building_id', building_id,
         'space_id', space_id,
         'asset_type_id', asset_type_id,
         'captured_at', captured_at)
   WHERE id = ?`
